import Backbone from 'backbone'
import NavItemModel from '../models/nav-item'
import nav from '../../assets/nav.json'

const NavItemList = Backbone.Collection.extend({
    model: NavItemModel,
    initialize() {
        this.reset(nav)
    }
})

export default NavItemList
